import eligiblePoses from '../../PackageBuilders/MultiPose/poseEligibility';

// The pure half of the free-item picker (#5747), kept out of the component so
// the decisions are unit-testable: which designs this child has a usable
// photo for, which photo to start on, and whether the page may decide yet.

// Each add-on in the offer's set, with the poses that design can hold --
// poseEligibility is the ONE rule, the same one the gifts page applies. A
// design with no usable photo is NOT offered: empty is a valid answer, and a
// fallback that re-offered the refused photos is the bug that rule exists to
// stop. The result is the designs the page shows, in the set's order.
export function selectableDesigns(addons, poses, orientations = {}) {
  return (addons || [])
    .map((addon) => ({ addon, poses: eligiblePoses(poses || [], addon, orientations, false) }))
    .filter((entry) => entry.poses.length > 0);
}

// The photo to start on for a design: the favourite (the first pose on the
// package just built) when that design can hold it, else the design's first
// usable photo.
export function defaultPoseFor(design, favouritePoseId) {
  if (!design) return null;
  const favourite = design.poses.find((p) => String(p?.id) === String(favouritePoseId));
  return favourite || design.poses[0] || null;
}

// May the page take its show/skip decision yet? Same contract as the magnet
// page's readyToDecide: never decide on placeholder data, which skipped that
// page for every customer once.
export function readyToDecide({
  loadingPackage, packageId, loadingOffer, loadingCart, poses, posesPlaceholder, backgroundsPlaceholder = false,
}) {
  if (loadingPackage || loadingOffer || loadingCart) return false;
  if (!packageId) return false;
  if (!poses || posesPlaceholder) return false;
  if (backgroundsPlaceholder) return false;
  return true;
}
